import { ROUTE_PATHS } from 'app/utils/route';
import { useLocation } from 'react-router-dom';

const useIsDashbord = () => {
    const location = useLocation();

    const isDashbord = () =>
        location.pathname === `/${ROUTE_PATHS.home}` ||
        location.pathname.includes('dashboard');

    return isDashbord();
};

export default useIsDashbord;
